import { GeneralArrowDownIcon } from '@outdoorsyco/bonfire';
import React, { useEffect, useState } from 'react';

import ProgressCircleIcon from '@/assets/escapes/progress-circle.svg';

export const ProgressCircle: React.FC = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const progress = (scrolled / scrollHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="fixed flex items-center justify-center rounded-full bottom-6 right-6 w-14 h-14 bg-[#EFEFEC] z-1299 md:!m-0">
      <div className="relative flex items-center justify-center w-12 h-12 border-2 rounded-full border-[#42526E33]">
        <ProgressCircleIcon
          className="absolute w-13 h-13"
          style={{ '--dash-offset': `${100 - scrollProgress}` }}
        />
        <GeneralArrowDownIcon color="#2B381F" height={30} />
      </div>
    </div>
  );
};
